import * as yup from 'yup';
import { nullableNumber, selectSchema } from 'Common/Forms/ValidationSchemas/BaseSchemas';
import { UserDetails } from 'Models/UserModels';

export const EditProfileSchema = yup.object().shape<Pick<UserDetails, 'notificationFrequency' | 'teamId'>>({
	notificationFrequency: selectSchema('Notification Frequency'),
	teamId: nullableNumber(),
});
